import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { blockUser } from "../../../actions/blockuser";

const BlockUser = ({
  setBlockUser,
  profile: {
    role,
    channelid,
    avatar,
    firstname,
    lastname,
    jobtitle,
    companyname,
    location,
  },
  blockUser,
}) => {
  return (
    <Fragment>
      <div className="messages-overlay">
        <div className="request-box">
          <i
            className="fas fa-times fa-3x message-x"
            onClick={() => setBlockUser({ request: false, confirm: false })}
          ></i>
          <div className="flex-center">
            <div className="online-avi-container">
              <div
                className={
                  role === "mentor"
                    ? "avi-color-border-alt red"
                    : role === "innovator"
                    ? "avi-color-border-alt green"
                    : "avi-color-border-alt blue"
                }
              >
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                  className="drop-down-result-avi"
                  alt="avatar"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span
                    className={
                      role === "mentor"
                        ? "red name-font bold"
                        : role === "innovator"
                        ? "green name-font bold"
                        : "blue name-font bold"
                    }
                  >
                    {firstname} {lastname}
                  </span>
                </li>
                <li className="user-online-item">{jobtitle}</li>
                <li className="user-online-item">{companyname}</li>
                <li className="user-online-item">
                  {location.city}, {location.state}
                </li>
              </ul>
            </div>
          </div>
          <div className="user-request-text">
            Are you sure you would like to block user{" "}
            <span className="red bold">
              {firstname} {lastname}
            </span>
            ? This user will no longer be able to view your profile or
            participate in your live stream chat.
          </div>
          <div className="flex-center">
            <button
              className="user-request-button background-red"
              onClick={() => {
                blockUser(channelid);
                setBlockUser({ request: false, confirm: true });
              }}
            >
              <i className="fa-solid fa-ban fa-sm mr-5"></i>
              Block
            </button>
            <button
              className="user-request-button background-red"
              onClick={() => setBlockUser({ request: false, confirm: false })}
            >
              <i className="fas fa-times fa-sm mr-5 bold"></i>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

BlockUser.propTypes = {
  blockUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  blockUser,
})(BlockUser);
